import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from "react";

export default function CommonPdfFooter() {

    const styles = StyleSheet.create( {
        footer: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
        },
        footerText: {
            color: 'white',
            position: 'absolute',
            marginTop: 25,
            marginLeft: 20,
            fontSize: 10,
        },
    } );

    return (
        <View style={ { ...styles.footer, marginTop: 0, height: '30px' } } fixed>
            <View style={ {
                flex: 1,
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                paddingRight: '20px',
                paddingBottom: '5px'
            } }>
                <Text style={ { fontSize: 8, color: "#000000" } } render={ ( { pageNumber, totalPages } ) => (
                    `${ pageNumber } / ${ totalPages }`
                ) }/>
            </View>
        </View>
    );
}
